export const Camera = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3996 8.79998H6.59961M8.99961 6.39998V11.2"
        stroke="#2741D6"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7.2224 15.2H10.7776C13.2744 15.2 14.5232 15.2 15.42 14.612C15.8071 14.3585 16.1403 14.0312 16.4008 13.6488C17 12.7688 17 11.5424 17 9.09122C17 6.64002 17 5.41362 16.4008 4.53362C16.1403 4.15121 15.8071 3.82391 15.42 3.57042C14.844 3.19202 14.1224 3.05682 13.0176 3.00882C12.4904 3.00882 12.0368 2.61682 11.9336 2.10882C11.8547 1.73671 11.6498 1.40325 11.3535 1.16478C11.0571 0.926312 10.6876 0.797466 10.3072 0.800019H7.6928C6.9024 0.800019 6.2216 1.34802 6.0664 2.10882C5.9632 2.61682 5.5096 3.00882 4.9824 3.00882C3.8784 3.05682 3.1568 3.19282 2.58 3.57042C2.19323 3.82399 1.86022 4.15129 1.6 4.53362C1 5.41362 1 6.63922 1 9.09122C1 11.5432 1 12.768 1.5992 13.6488C1.8584 14.0296 2.1912 14.3568 2.58 14.612C3.4768 15.2 4.7256 15.2 7.2224 15.2Z"
        stroke="#2741D6"
        strokeWidth="1.5"
      />
      <path
        d="M14.6008 6.39998H13.8008"
        stroke="#2741D6"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const WalletMoney = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3072 7.39501C15.2635 7.39298 15.2197 7.39223 15.1759 7.39276H13.3497C11.8557 7.39276 10.5762 8.57851 10.5762 10.125C10.5762 11.6715 11.8557 12.8573 13.3504 12.8573H15.1752C15.2212 12.8578 15.2649 12.8568 15.3064 12.8543C15.6147 12.8343 15.9052 12.703 16.124 12.4849C16.3428 12.2668 16.4749 11.9767 16.4959 11.6685C16.4989 11.6243 16.4989 11.577 16.4989 11.5335V8.71651C16.4989 8.67301 16.4989 8.62576 16.4959 8.58151C16.475 8.27342 16.3429 7.98341 16.1243 7.76533C15.9057 7.54725 15.6153 7.41593 15.3072 7.39576M13.1899 10.854C13.5747 10.854 13.8874 10.5285 13.8874 10.1258C13.8874 9.72301 13.5747 9.39751 13.1899 9.39751C12.8052 9.39751 12.4932 9.72301 12.4932 10.1258C12.4932 10.5285 12.8044 10.854 13.1899 10.854Z"
        fill="#2741D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1755 13.95C15.2006 13.9491 15.2256 13.9542 15.2484 13.9647C15.2713 13.9752 15.2913 13.991 15.3069 14.0107C15.3225 14.0304 15.3333 14.0535 15.3383 14.0781C15.3434 14.1028 15.3426 14.1282 15.336 14.1525C15.1905 14.6715 14.9602 15.114 14.5905 15.486C14.0498 16.0312 13.3635 16.2735 12.516 16.3882C11.6925 16.5 10.641 16.5 9.312 16.5H7.78425C6.456 16.5 5.40375 16.5 4.58025 16.3882C3.73275 16.2735 3.0465 16.0312 2.50575 15.486C1.965 14.9422 1.725 14.25 1.611 13.3965C1.5 12.5655 1.5 11.505 1.5 10.1662V10.0837C1.5 8.745 1.5 7.68375 1.611 6.85425C1.725 6 1.965 5.31 2.505 4.76325C3.04575 4.21875 3.732 3.97575 4.5795 3.86175C5.40375 3.75 6.456 3.75 7.78425 3.75H9.312C10.6403 3.75 11.6925 3.75 12.516 3.86175C13.3635 3.9765 14.0498 4.21875 14.5905 4.76325C14.9602 5.136 15.1905 5.5785 15.336 6.09825C15.3425 6.12246 15.3431 6.14785 15.338 6.17238C15.3329 6.19691 15.3221 6.2199 15.3065 6.23951C15.2909 6.25912 15.2709 6.27481 15.2482 6.28531C15.2254 6.29582 15.2005 6.30085 15.1755 6.3H13.3507C11.3003 6.3 9.4935 7.93275 9.4935 10.125C9.4935 12.3172 11.301 13.95 13.3515 13.95H15.1755ZM4.2105 6.6645C4.13909 6.66479 4.06844 6.67915 4.00259 6.70675C3.93673 6.73435 3.87695 6.77465 3.82667 6.82535C3.77639 6.87605 3.73658 6.93616 3.70953 7.00224C3.68248 7.06833 3.6687 7.13909 3.669 7.2105C3.669 7.51275 3.91125 7.75725 4.2105 7.75725H7.1025C7.4025 7.75725 7.64475 7.51275 7.64475 7.2105C7.64515 7.06622 7.58827 6.92768 7.4866 6.8253C7.38493 6.72293 7.24678 6.6651 7.1025 6.6645H4.2105Z"
        fill="#2741D6"
      />
      <path
        d="M5.83301 3.018L7.30151 1.93575C7.68476 1.65256 8.14873 1.49974 8.62526 1.49974C9.10179 1.49974 9.56575 1.65256 9.94901 1.93575L11.4258 3.024C10.8078 3 10.1178 3 9.36251 3H7.73501C7.04351 3 6.40826 3 5.83301 3.018Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const Toggle = ({ onClick, isActive }) => {
  return (
    <svg
      className="cursor-pointer transition-transform duration-200 hover:scale-105"
      onClick={onClick}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background track */}
      <path
        d="M3.75 20C3.75 17.4583 4.75967 15.0208 6.55689 13.2236C8.35412 11.4263 10.7917 10.4167 13.3333 10.4167H26.6667C29.2083 10.4167 31.6459 11.4263 33.4431 13.2236C35.2403 15.0208 36.25 17.4583 36.25 20C36.25 22.5417 35.2403 24.9792 33.4431 26.7764C31.6459 28.5737 29.2083 29.5833 26.6667 29.5833H13.3333C10.7917 29.5833 8.35412 28.5737 6.55689 26.7764C4.75967 24.9792 3.75 22.5417 3.75 20Z"
        fill={isActive ? "#2741D6" : "#CDCDCD"}
        className="transition-all duration-300 ease-in-out"
      />
      {/* Sliding circle */}
      <circle
        cx="13.33"
        cy="20"
        r="5.83"
        fill="white"
        stroke="#f0f0f0"
        strokeWidth="0.5"
        style={{
          transform: isActive ? "translateX(13.34px)" : "translateX(0px)",
          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      />
    </svg>
  );
};

export const CopyOutline = () => {
  return (
    <svg
      className="cursor-pointer"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.41797 5.18V3.255C5.41808 2.94422 5.54161 2.6462 5.76141 2.42648C5.98121 2.20677 6.27927 2.08334 6.59005 2.08334H16.7459C17.0567 2.08334 17.3549 2.20682 17.5747 2.42663C17.7945 2.64644 17.918 2.94456 17.918 3.25542V13.4117C17.9179 13.7224 17.7944 14.0203 17.5747 14.24C17.355 14.4597 17.057 14.5832 16.7463 14.5833H14.7996"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4123 5.41667H3.25523C2.94452 5.41689 2.64661 5.54048 2.42698 5.76026C2.20736 5.98005 2.08398 6.27804 2.08398 6.58875V16.7446C2.08398 17.0554 2.20747 17.3536 2.42728 17.5734C2.64709 17.7932 2.94521 17.9167 3.25607 17.9167H13.4123C13.723 17.9166 14.021 17.7931 14.2407 17.5734C14.4604 17.3537 14.5839 17.0557 14.584 16.745V6.58792C14.5838 6.27728 14.4602 5.97944 14.2405 5.75982C14.0208 5.5402 13.723 5.41678 13.4123 5.41667Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Send = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.3296 3.67C20.1405 3.48217 19.9032 3.35012 19.6438 3.28838C19.3845 3.22663 19.1132 3.23757 18.8596 3.32L4.22964 8.2C3.95831 8.28598 3.71854 8.45043 3.54062 8.6726C3.3627 8.89476 3.25461 9.16467 3.23 9.44822C3.20539 9.73178 3.26537 10.0163 3.40235 10.2658C3.53933 10.5153 3.74718 10.7186 3.99964 10.85L10.0696 13.85L13.0696 19.94C13.1902 20.1784 13.3747 20.3785 13.6025 20.518C13.8304 20.6575 14.0925 20.7309 14.3596 20.73H14.4596C14.7457 20.7089 15.0189 20.6023 15.2436 20.424C15.4683 20.2456 15.6341 20.0038 15.7196 19.73L20.6696 5.14C20.758 4.88794 20.773 4.61595 20.7128 4.3557C20.6526 4.09546 20.5197 3.85766 20.3296 3.67ZM4.84964 9.58L17.6196 5.32L10.5296 12.41L4.84964 9.58ZM14.4296 19.15L11.5896 13.47L18.6796 6.38L14.4296 19.15Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const Gift = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 11V15C4 18.3 4 19.95 5.025 20.975C6.05 22 7.7 22 11 22H13C16.3 22 17.95 22 18.975 20.975C20 19.95 20 18.3 20 15V11M12 5.857C12 4.83406 11.5936 3.85302 10.8703 3.12969C10.147 2.40636 9.16594 2 8.143 2H7.786C6.8 2 6 2.799 6 3.786C6 4.63841 6.33862 5.4559 6.94136 6.05864C7.5441 6.66138 8.36159 7 9.214 7H12M12 5.857V7M12 5.857C12 4.83406 12.4064 3.85302 13.1297 3.12969C13.853 2.40636 14.8341 2 15.857 2H16.214C17.2 2 18 2.799 18 3.786C18 4.20807 17.9169 4.626 17.7553 5.01594C17.5938 5.40588 17.3571 5.76019 17.0586 6.05864C16.7602 6.35709 16.4059 6.59383 16.0159 6.75535C15.626 6.91687 15.2081 7 14.786 7H12M12 11V22M3 9C3 8.252 3 7.878 3.201 7.6C3.34356 7.40899 3.53253 7.25754 3.75 7.16C4.098 7 4.565 7 5.5 7H18.5C19.435 7 19.902 7 20.25 7.16C20.478 7.266 20.667 7.418 20.799 7.6C21 7.878 21 8.252 21 9C21 9.748 21 10.121 20.799 10.4C20.6564 10.591 20.4675 10.7425 20.25 10.84C19.902 11 19.435 11 18.5 11H5.5C4.565 11 4.098 11 3.75 10.84C3.53253 10.7425 3.34356 10.591 3.201 10.4C3 10.121 3 9.748 3 9Z"
        stroke="#2741D6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
